import api from './api';

export interface StoreDraw {
  id: string;
  prizeDescription: string;
  drawDate: string;
  campaign: {
    id: string;
    name: string;
  };
  winnerStore: {
    id: string;
    name: string;
    address?: string;
  };
  createdAt: string;
}

export interface CreateStoreDrawDto {
  campaignId: string;
  prizeDescription: string;
}

export const storeDrawService = {
  async performStoreDraw(data: CreateStoreDrawDto): Promise<StoreDraw> {
    const response = await api.post('/store-draws', data);
    return response.data;
  },

  async getAllStoreDraws(campaignId?: string): Promise<StoreDraw[]> {
    const params = campaignId ? { campaignId } : {};
    const response = await api.get('/store-draws', { params });
    return response.data;
  },

  async getStoreDrawById(id: string): Promise<StoreDraw> {
    const response = await api.get(`/store-draws/${id}`);
    return response.data;
  },

  async deleteStoreDraw(id: string): Promise<void> {
    await api.delete(`/store-draws/${id}`);
  },
};

